import React from 'react';
import { MaxWidthText } from '@allenai/varnish2/components';

export const About = () => {
    return (
        <MaxWidthText>
            <h1>About COBRA Frames</h1>
            <p>
                COBRA Frames is a formalism that supports contextual reasoning about effects and harms of offensive statements.
                It is based on the <a href="https://arxiv.org/abs/2306.01985">COBRA</a> paper and is designed to be used as a
                research prototype to explore the space of offensive language detection and mitigation.
            </p>
            <p>
                If you have any questions, concerns or feedback please don't hesitate to reach out.
            </p>
        </MaxWidthText>
    );
};
